export const createErrorMessage = (error: any, path: string[] = ['data', 'error']): string => {
  let message = ''

  if (error?.status === '403') {
    return error?.message || ''
  }

  const errorObject = path.length > 0 ? path.reduce((acc, key) => acc?.[key], error) ?? {} : error

  if (!errorObject || typeof errorObject !== 'object') return message

  Object.entries(errorObject).forEach(([_, value]) => {
    if (Array.isArray(value)) {
      value.forEach(fieldError => {
        if (typeof fieldError === 'string') {
          message += `${fieldError}, `
        }
      })
    }
  })

  return message.slice(0, -2)
}

export const createVacationErrorMessage = (error: unknown): string => {
  if (
    typeof error === 'object' &&
    error !== null &&
    'data' in error &&
    typeof (error as any).data === 'object' &&
    'message' in (error as any).data &&
    typeof (error as any).data.message === 'string'
  ) {
    return (error as any).data.message.toString()
  }
  return ''
}
